import Gmodal from 'glory-modal';

export function contactModal(rep) {


    const modalbody = document.querySelector('.gmodal__body');

    let selector = '#modal';
    var modalEl = document.querySelector(selector);

    let config = {
        stickySelectors: [],
        animation: false,
        backdrop: true,
        closeBackdrop: true,
        keyboard: true
    }

    let modal = new Gmodal(selector, config);
    modal.open();

    let recipientField = document.querySelector("[name='fields[salesRep]']");
    recipientField.value = rep.email;

    let $form = document.querySelector('#contact-sales-rep');
    let submitHandler = null;

    $form.addEventListener('onBeforeFormieSubmit', onBeforeSubmit);
    $form.addEventListener('onFormieValidate', onValidate);

    function onBeforeSubmit(e) {
        submitHandler = e.detail.submitHandler;
    }

    function onValidate(e) {
        // Prevent the form from submitting while we check some things
        e.preventDefault();
        
        let invalid = e.detail.invalid;

        // Some custom validation logic...
        if (invalid) {

            // Show that the form is invalid
            submitHandler.formSubmitError();

        } else {

            gtag('event', 'sales_rep', {
                'company_name': `${rep.company}`,
                'state': `${rep.state}`,
                'event_type': 'form_submit'
            });

            // Otherwise, tell Formie to submit the form. Because we have stopped the process,
            // we need to manually start it back up again.
            submitHandler.submitForm();
        }
    }
    modalEl.addEventListener('gmodal:beforeclose', function(evt) {
        recipientField.value = '';
    })      
}